import React, { useState, useRef } from 'react';
import {
    List, Datagrid, TextField, EditButton, FunctionField, SimpleList, useRefresh, SimpleForm, usePermissions
} from 'react-admin';
import { useMediaQuery, CircularProgress, makeStyles, Button, Dialog, DialogActions, DialogContent, TextField as MuiTextField } from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import RaGenderField from './components/RaGenderField';
import moment from 'moment'
import config from "./config.json";
import RaAutocompleteInput from './components/RaAutocompleteInput';
import { Helmet } from "react-helmet";
import CustomPagination from './components/CustomPagination';
import ScrollableTable from './components/ScrollableTable';
import { useLocation } from 'react-router-dom';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import { Link } from "react-router-dom";
import queryString from 'query-string';
import { hideMobileNumber, hideName } from "./sharedData";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
});

/*function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};*/

const CATEGORY = "APP USERS SECTION"
const renderDOB = row => row.date_of_birth === "" ? "" : moment(row.date_of_birth).format('MMMM Do YYYY');

const searchTypes = ["Mobile Number", "Vehicle Number"];

export const JammuUsersList = (props) => {
    const eventTracker = UseAnalyticsEvent()
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [showFilter] = useState(sessionStorage.getItem("role") === "admin");
    const { permissions } = usePermissions();
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchType, setSearchType] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    let filterTypesInitState = [
        {
            filterType: "App Users",
            dataList: [{ name: "ParkSmart Users", id: 1 }, { name: "Jammu Users", id: 2 }, { name: "Noida Users", id: 3 }, { name: "Paytm Users", id: 4 }],
            listType: "Static",
            caseType: "Static",
            showFilter: showFilter
        },
        {
            filterType: "Permit Users",
            dataList: [{ name: "Permit Users", id: 1 }],
            listType: "Static",
            caseType: "Static",
            showFilter: showFilter
        },
        {
            filterType: "Card Holders",
            dataList: [{ name: "NFC Users", id: 1 }, { name: "Non NFC Users", id: 0 }],
            listType: "Static",
            caseType: "Static",
            showFilter: showFilter
        }
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, search: { value: search, type: searchType } };

    React.useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "App Users") {
                    values = { ...values, appUsers: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Permit Users") {
                    values = { ...values, permitUsers: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Card Holders") {
                    values = { ...values, nfcUsers: filterListValue[val].id === 0 || filterListValue[val].id === 1 ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, " APP USERS LIST")
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchType} setSearchTypes={setSearchType} searchTypeState={searchTypes} />
                {showFilter && <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />}
            </div>
            <List
                {...props}
                style={{marginTop: 20}}
                empty={false}
                title="App Users"
                bulkActionButtons={false}
                exporter={false}
                filter={filter}
                actions={false}
                pagination={<CustomPagination />}
            >
                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => hideName(record.name.toUpperCase())}
                        secondaryText={record => (<div>
                            {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{hideMobileNumber(record.mobile)}</div>}
                            {record.email && <div><span style={{ color: "#5a5a5a" }}>Email: </span>{record.email}</div>}
                            {record.date_of_birth && <div><span style={{ color: "#5a5a5a" }}>DOB: </span>{moment(record.date_of_birth).format('MMMM Do YYYY')}</div>}
                            {record.parking_name && settingFilterFormat && settingFilterFormat.permitUsers === 'Permit Users' && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            {permissions === 'admin' && <FunctionField
                                source="mobile"
                                label="App User"
                                render={record => {
                                    return <>
                                        {
                                            record.noida_user === 1 || record.jammu_user === 1 || record.paytm_user === 1 ? <div style={{ color: "#5a5a5a" }}>
                                                App User:
                                                <span style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", columnGap: 5 }}>
                                                    {
                                                        record.main_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#18cc6919", color: "#18ccc69", borderRadius: 10 }}>ParkSmart User</p>
                                                    }
                                                    {
                                                        record.paytm_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#109cf119", color: "#109cf1", borderRadius: 10 }}>Paytm User</p>
                                                    }
                                                    {
                                                        record.jammu_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#f67b3419", color: "#f67b34", borderRadius: 10 }}>Jammu User</p>
                                                    }
                                                    {
                                                        record.noida_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#18cc6919", color: "#18cc69", borderRadius: 10 }}>Noida User</p>
                                                    }
                                                </span>
                                            </div>
                                                : null
                                        }
                                    </>
                                }}

                            />}
                            {!viewOnly && settingFilterFormat && settingFilterFormat.permitUsers !== 'Permit Users' && record && <AssignRequest label="Payment Card" record={record} />}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        rightIcon={record => <EditButton style={{ letterSpacing: 1, padding: "6px 20px 6px 15px", textTransform: "none", borderRadius: 100 }} disableElevation record={record} label='Payment Card' variant="contained" />}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <RaGenderField source="gender" label="" />
                        <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />

                        <FunctionField source="mobile" label="Mobile" render={record => record && record.mobile && settingFilterFormat && settingFilterFormat.permitUsers === 'Permit Users' ?
                            <Link to={`/rfidData?${queryString.stringify({ mobile: record.mobile })}`} style={{ textDecoration: "none" }}>
                                <span style={{ color: "#334d6e", fontWeight: "bold" }}>{hideMobileNumber(record.mobile)}</span>
                            </Link> : hideMobileNumber(record.mobile)} />
                        {settingFilterFormat && settingFilterFormat.permitUsers === 'Permit Users' && <TextField source="parking_name" label="Parking Name" />}
                        <TextField source="email" label="Email" />
                        <FunctionField
                            source="date_of_birth"
                            label="DOB"
                            render={record => record && renderDOB(record)}
                        />
                        {!viewOnly && settingFilterFormat && settingFilterFormat.permitUsers !== 'Permit Users' && <AssignRequest label="Payment Card" />}
                        {permissions === 'admin' && <FunctionField
                            source="mobile"
                            label="App User"
                            render={record => {
                                return <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", columnGap: 5 }}>
                                    {
                                        record.main_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#18cc6919", color: "#18cc69", borderRadius: 10 }}>ParkSmart User</p>
                                    }
                                    {
                                        record.paytm_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#109cf119", color: "#109cf1", borderRadius: 10 }}>Paytm User</p>
                                    }
                                    {
                                        record.jammu_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#f67b3419", color: "#f67b34", borderRadius: 10 }}>Jammu User</p>
                                    }
                                    {
                                        record.noida_user === 1 && <p style={{ padding: "2px 10px", backgroundColor: "#18cc6919", color: "#18cc69", borderRadius: 10 }}>Noida User</p>
                                    }
                                </div>
                            }}

                        />}
                    </Datagrid>
                }
            </List>
        </div>
    )
};

/*
function AssignRequest(props) {
    const classes = useStyles();
    const { record, source } = props;

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const refresh = useRefresh();
    //const notify = useNotify();
    //const dispatch = useDispatch();

    const [resolved, setResolved] = React.useState(null);
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [loading, setLoading] = useState(false);

    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [amountText, setAmountText] = useState(0);
    const [months, setMonths] = useState(1);
    const [gstToggle, setGstToggle] = useState(false);
    const [gstAmount, setGstAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [nfcCardCharges, setnfcCardCharges] = useState(100)

    // const [startDate, setStartDate] = useState(new Date());
    const [paymentMethod, setPaymentMethod] = useState('Digital');

    const [selectedOptions, setSelectedOptions] = useState("")
    const surfaceId = useRef("")
    const [emailAddress, setEmailAddress] = useState(record.email ? record.email : "")

    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    }


    const openDialog = state => {
        setResolved(state);
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
        //setSelectedOptions("")
    };

    // Payment Handler
    const handleUpdate = (event) => {
        event.preventDefault();

        if (resolved !== 1) {
            removeHandler()
        }
        else {
            let emailRegex = /\S+@\S+\.\S+/;
            if (selectedOptions == null || selectedOptions === '') {
                notify('NFC Card is required', 'warning');
                return;
            }
            if (emailAddress === "") {
                return notify("Please enter your email address.", "warning")
            }
            if (!emailRegex.test(emailAddress)) {
                return notify("Invalid email address.", "warning")
            }

            if (
                totalAmount == null ||
                totalAmount === '' ||
                isNaN(totalAmount) ||
                parseFloat(totalAmount) < 0
            ) {
                notify('Amount is required', 'warning');
                return;
            }

            if (paymentMethod == null || paymentMethod === '') {
                notify('Payment Method is required', 'warning');
                return;
            }
            setLoading(true);
            if (resolved === 1 && paymentMethod === "Digital") {
                //payment process
                const params = {
                    user_id: record.id,
                    name: record.name,
                    mobile_number: record.mobile,
                    price: totalAmount,
                    payment_method: paymentMethod,
                    nfc_uid: selectedOptions != null && selectedOptions !== "" ? selectedOptions : "",
                    surface_id: surfaceId != null && surfaceId !== "" ? surfaceId.current : "",
                    email_address: emailAddress
                }

                closeDialog();
                closePaymentFailedDialog();
                fetch(`${config.HOST_NAME}/crm/v3/issueNfcCard/initiateNfcCardPayment/jammu`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        price: totalAmount,
                        mobile_number: params.mobile_number,
                        nfc_uid: params.nfc_uid,
                        user_id: params.user_id,
                        surface_id: params.surface_id,
                        name: params.name,
                        email_address: params.email_address
                    }),
                })
                    .then((response) => {
                        saveTokens(response)
                        return response.json()
                    })
                    .then((json) => {
                        if (json.success) {
                            const order = json.data.order;
                            var options = {
                                description: 'Permit Charges',
                                currency: order.currency,
                                key: config.RAZOR_PAY_KEY_ID,
                                amount: order.amount,
                                name: 'ParkSmart',
                                order_id: order.id,
                                notes: {
                                    nfc_uid: params.nfc_uid ? params.nfc_uid : "",
                                },
                                prefill: {
                                    name: params.name,
                                    contact: params.mobile,
                                },
                                theme: {
                                    color: customTheme.palette.primary.main,
                                },
                                modal: {
                                    ondismiss: () => {
                                        setLoading(false);
                                        const description = 'Payment is cancelled by user';
                                        setPaymentFailedDialog(description);
                                    },
                                },
                                handler: (checkoutData) => {
                                    fetch(`${config.HOST_NAME}/crm/v3/issueNfcCard/verifyNfcCardPayment/jammu`, {
                                        method: 'POST',
                                        headers: {
                                            'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                            'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            ...checkoutData,
                                            transaction_id: json.data.transaction_id,
                                            ...params,
                                        }),
                                    })
                                        .then((response) => {
                                            saveTokens(response)
                                            return response.json()
                                        })
                                        .then((json) => {
                                            setLoading(false);
                                            if (json.success) {
                                                notify('Payment Successful', 'success');
                                                refresh();
                                                //refreshPendingRequestCount();
                                            } else {
                                                setPaymentFailedDialog(json.message);
                                            }
                                        })
                                        .catch((error) => {
                                            setLoading(false);
                                            setPaymentFailedDialog('Could not verify Payment');
                                        })
                                },
                            }
                            const razorpay = new window.Razorpay(options);
                            razorpay.on('payment.failed', function ({ error }) {
                                setLoading(false);
                                let description;
                                if (isJsonString(error.description)) {
                                    const errorObj = JSON.parse(error.description)
                                    if (errorObj.error) {
                                        description = errorObj.error.description;
                                    } else {
                                        description = errorObj.description;
                                    }
                                } else {
                                    description = error.description;
                                }
                                setPaymentFailedDialog(description)
                            })

                            razorpay.open();
                        } else {
                            setLoading(false);
                            notify(json.message, 'warning');
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setLoading(false);
                        notify('Check your internet connection', 'warning');
                    })
            }
        }
    }

    // const assignHandler = () => {
    //     //Api request 
    //     setAssignLoader(true)
    //     fetch(`${config.HOST_NAME}/crm/v3/assignInventoryWalletTags`, {
    //         method: 'POST',
    //         headers: {
    //             Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({ commuter_userID: record.id, surface_id: surfaceId.current, nfc_uid: selectedOptions }),
    //     })
    //         .then(response => response.json())
    //         .then(json => {
    //             if (json.success) {
    //                 notify("Successfully Assigned", "success");
    //                 setOpen(false)
    //                 setAssignLoader(false)
    //                 setSelectedOptions("")
    //                 refresh()
    //             } else {
    //                 notify(json.message, "warning");
    //                 setAssignLoader(false)
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //             notify("Something went wrong", "warning");
    //             setAssignLoader(false)
    //         });

    // }

    const removeHandler = () => {
        //Api request 
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/removeAssignedTags`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ commuter_userID: record.id }),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Successfully Removed", "success");
                    closeDialog()
                    setLoading(false)
                    refresh()
                } else {
                    notify(json.message, "warning");
                    //setAssignLoader(false)
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    if (!record) return null
    if (record.jammu_user !== 1) return null
    return (
        <>
            <Helmet>
                <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
            </Helmet>
            <div style={{ marginTop: isSmallDevice ? 5 : 0, textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice || record[source] === -1 ? "flex" : "block", flex: 1, columnGap: 8 }}>
                {loading ?
                    <CircularProgress color="secondary" size={20} />
                    : <>
                        {
                            record.nfc_uid == null && <Button variant="contained" color="primary" style={{ borderRadius: 100 }} onClick={() => openDialog(1)} disableElevation>
                                Assign Card
                            </Button>
                        }
                        {
                            record.nfc_uid !== null && <div variant="contained" style={{ color: customTheme.palette.error.main, lineHeight: "6px", fontWeight: "bold" }}>
                                <p style={{ color: "#BDBDBD" }}>{record.surface_id}</p>
                                <p onClick={() => openDialog(0)} style={{ cursor: "pointer" }}>Remove Card</p>
                            </div>
                        }
                    </>}

                <Portal>
                    <Dialog
                        open={!!paymentFailedDialog}
                        onClose={closePaymentFailedDialog}
                        classes={{ paper: classes.dialogPaper }}
                    >
                        <DialogTitle style={{ color: customTheme.palette.error.main }}>
                            <div style={{ fontSize: 16, textAlign: 'center' }}>
                                Payment Failed!
                            </div>
                        </DialogTitle>
                        <DialogContent
                            style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}
                        >
                            Description: {paymentFailedDialog}
                        </DialogContent>
                        <DialogActions
                            style={{ display: 'flex', justifyContent: 'space-evenly' }}
                        >
                            <Button
                                className={classes.dialogButton}
                                variant="outlined"
                                color="default"
                                onClick={closePaymentFailedDialog}
                            >
                                Cancel
                            </Button>
                            <Button
                                disableElevation
                                className={classes.dialogButton}
                                variant="contained"
                                color="secondary"
                                onClick={handleUpdate}
                            >
                                Retry
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Portal>

                <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaperBig }}>

                    {resolved !== 1 && record.nfc_uid !== null ?
                        <DialogContent>
                            Are you sure you want to <strong>Remove</strong> this card.
                        </DialogContent> :

                        <SimpleForm style={{ padding: '20px 22px 0px 22px' }} toolbar={false}>
                            <div style={{ width: '100%' }}>
                                <div style={{ width: "100%" }}>
                                    <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Select NFC Card*</div>
                                    <RaAutocompleteInput
                                        source="search"
                                        resourceParam="search"
                                        filter={{ available: true }}
                                        customSort={["surface_id", "ASC"]}
                                        resourcePath="cardsInventory"
                                        label=""
                                        getOptionValue={(option) => {
                                            //setSurfaceId(option['surface_id'])
                                            surfaceId.current = option['surface_id']
                                            return option['nfc_uid']
                                        }}
                                        getOptionLabel={(option) =>
                                            `${option['surface_id']} - ${option['nfc_uid']}`
                                        }
                                        onSelect={(value) => setSelectedOptions(value)}
                                        style={{ marginTop: 7, marginBottom: 15 }}
                                    />
                                </div>

                                <div>
                                    <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Email Address*</div>
                                    <MuiTextField
                                        variant='outlined'
                                        value={emailAddress}
                                        onChange={(e) => setEmailAddress(e.target.value)}
                                        size="small"
                                        style={{ marginBottom: 20, marginTop: 7 }}
                                    />

                                    {
                                        selectedOptions &&

                                        <ValidityAmountInputForMonthlyPassRequest
                                            accessKeyId={record.access_key_id}
                                            vehicle_type={record.vehicle_type}
                                            amountText={amountText}
                                            setAmountText={(val) => setAmountText(val)}
                                            gstToggle={gstToggle}
                                            setGstToggle={(val) => setGstToggle(val)}
                                            gstAmount={gstAmount}
                                            setGstAmount={(val) => setGstAmount(val)}
                                            months={months}
                                            setMonths={(val) => setMonths(val)}
                                            totalAmount={totalAmount}
                                            setTotalAmount={(val) => setTotalAmount(val)}
                                            paymentMethod={paymentMethod}
                                            setPaymentMethod={(val) => setPaymentMethod(val)}
                                            nfcCardCharges={nfcCardCharges}
                                            selectedOptions={selectedOptions}
                                            setnfcCardCharges={(val) => setnfcCardCharges(val)}

                                        />
                                    }

                                </div>

                                <div style={{ width: "100%", borderBottom: "1px solid #DEDEDE" }}></div>
                            </div >
                        </SimpleForm >
                    }

                    <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={closeDialog} variant='contained' disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }}>Cancel</Button>
                        <Button
                            className={resolved !== 1 ? classes.errorText : null}
                            variant='contained'
                            onClick={handleUpdate}
                            disableElevation
                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", color: "#FFFF", backgroundColor: resolved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main, }}
                        >
                            {resolved === 1
                                ? paymentMethod === 'Digital'
                                    ? 'Pay'
                                    : 'Accept'
                                : 'Remove'}
                        </Button>
                    </DialogActions>
                </Dialog >
            </div >
        </>
    );
}*/

/*
function ValidityAmountInputForMonthlyPassRequest(props) {


    const {
        gstToggle, setGstToggle, gstAmount, setGstAmount, totalAmount, setTotalAmount, nfcCardCharges, selectedOptions
    } = props

    const gstHandler = () => {
        setGstToggle(!gstToggle);

    }

    // WITH-OUT NFC CHARGES
    // if (gstToggle && !applyNfcCharges) {
    //     if(rfid){
    //         setGstAmount((9 / 100) * Number(amountText) + (9 / 100) * Number(amountText));
    //     }else{
    //         setGstAmount((9 / 100) * Number(amountText) + (9 / 100) * Number(amountText));
    //     }
    // }
    // if (gstToggle && amountText && !applyNfcCharges) {
    //     setTotalAmount((Number(amountText) + Number(gstAmount)));
    // }
    // if (!gstToggle && amountText && !applyNfcCharges) {
    //     setTotalAmount(amountText);
    // }

    // if (gstToggle && !applyNfcCharges) {
    //     if (rfid) {
    //         setGstAmount((9 / 100) * (Number(amountText) + Number(rfidCharges)) + (9 / 100) * (Number(amountText) + Number(rfidCharges)));
    //     } else {
    //         setGstAmount((9 / 100) * (Number(amountText)) + (9 / 100) * (Number(amountText)));
    //     }
    // }
    // if (gstToggle && amountText && !applyNfcCharges) {
    //     if (rfid) {
    //         setTotalAmount(((Number(amountText) + Number(rfidCharges)) + Number(gstAmount)));
    //     } else {
    //         setTotalAmount(((Number(amountText) + Number(gstAmount))));
    //     }
    // }
    // if (!gstToggle && amountText && !applyNfcCharges) {
    //     if (rfid) {
    //         setTotalAmount((Number(amountText) + Number(rfidCharges)));
    //     } else {
    //         setTotalAmount((Number(amountText)));
    //     }
    // }


    // WITH NFC CHARGES
    if (gstToggle) {
        if (selectedOptions) {
            setGstAmount((9 / 100) * Number(nfcCardCharges) + (9 / 100) * Number(nfcCardCharges));
        }
    }
    if (gstToggle) {

        if (selectedOptions) {
            setTotalAmount((Number(nfcCardCharges) + Number(gstAmount)));
        }
    }
    if (!gstToggle) {
        if (selectedOptions) {
            setTotalAmount(Number(nfcCardCharges));
        }
    }


    return (
        <div style={{ width: '100%', marginBottom: 15 }}>
            <FormControlLabel
                className="formLabel-regular"
                checked={gstToggle}
                onChange={gstHandler}
                control={<Checkbox color="primary" />}
                label="Add GST"
                style={{ marginTop: 5 }}
            />
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '80% 20%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    maxWidth: 500,
                }}
            >
                <>
                    {selectedOptions && <>
                        <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                            NFC Card Charges
                        </Typography>
                        <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                            ₹ {nfcCardCharges}
                        </Typography>
                    </>}

                    {
                        gstToggle && selectedOptions && <>
                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                CGST 9%
                            </Typography>
                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                ₹ {((9 / 100) * (Number(nfcCardCharges)))}
                            </Typography>
                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                SGST 9%
                            </Typography>
                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                ₹ {((9 / 100) * (Number(nfcCardCharges)))}
                            </Typography>
                        </>
                    }
                    <Typography style={{ fontSize: 15 }}>Total Amount</Typography>
                    <Typography style={{ fontSize: 15 }}>
                        ₹{' '}
                        {totalAmount}
                    </Typography>

                </>

            </div>
        </div>
    )
}*/

function AssignRequest(props) {
    const classes = useStyles();
    const { record, source } = props;

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const refresh = useRefresh();
    //const notify = useNotify();
    //const dispatch = useDispatch();

    const [resolved, setResolved] = React.useState(null);
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [loading, setLoading] = useState(false);

    const [selectedOptions, setSelectedOptions] = useState("")
    const surfaceId = useRef("")
    const [emailAddress, setEmailAddress] = useState("")

    const openDialog = state => {
        setResolved(state);
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
        //setSelectedOptions("")
    };

    const assignHandler = () => {
        //Api request 
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/assignInventoryWalletTags`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ commuter_userID: record.id, surface_id: surfaceId.current, nfc_uid: selectedOptions, email_address: emailAddress }),
        })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    notify("Successfully Assigned", "success");
                    setLoading(false)
                    setSelectedOptions("")
                    refresh()
                    closeDialog()
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });

    }

    const removeHandler = () => {
        //Api request 
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/removeAssignedTags`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ commuter_userID: record.id }),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Successfully Removed", "success");
                    closeDialog()
                    setLoading(false)
                    refresh()
                } else {
                    notify(json.message, "warning");
                    //setAssignLoader(false)
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    React.useEffect(() => {
        if (record) setEmailAddress(record.email)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if (!record) return null
    if (record.jammu_user !== 1) return null
    return (
        <>
            <Helmet>
                <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
            </Helmet>
            <div style={{ marginTop: isSmallDevice ? 5 : 0, textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice || record[source] === -1 ? "flex" : "block", flex: 1, columnGap: 8 }}>
                {loading ?
                    <CircularProgress color="secondary" size={20} />
                    : <>
                        {
                            record.nfc_uid == null && <Button variant="contained" color="primary" style={{ borderRadius: 100 }} onClick={() => openDialog(1)} disableElevation>
                                Assign Card
                            </Button>
                        }
                        {
                            record.nfc_uid !== null && <div variant="contained" style={{ color: customTheme.palette.error.main, lineHeight: "6px", fontWeight: "bold" }}>
                                <p style={{ color: "#BDBDBD" }}>{record.surface_id}</p>
                                <p onClick={() => openDialog(0)} style={{ cursor: "pointer" }}>Remove Card</p>
                            </div>
                        }
                    </>}

                <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaperBig }}>

                    {resolved !== 1 && record.nfc_uid !== null ?
                        <DialogContent>
                            Are you sure you want to <strong>Remove</strong> this card.
                        </DialogContent> :

                        <SimpleForm style={{ padding: '20px 22px 0px 22px' }} toolbar={false}>
                            <div style={{ width: '100%' }}>
                                <div style={{ width: "100%" }}>
                                    <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Select NFC Card*</div>
                                    <RaAutocompleteInput
                                        source="search"
                                        resourceParam="search"
                                        filter={{ available: true }}
                                        customSort={["surface_id", "ASC"]}
                                        resourcePath="cardsInventory"
                                        label=""
                                        getOptionValue={(option) => {
                                            //setSurfaceId(option['surface_id'])
                                            surfaceId.current = option['surface_id']
                                            return option['nfc_uid']
                                        }}
                                        getOptionLabel={(option) =>
                                            `${option['surface_id']} - ${option['nfc_uid']}`
                                        }
                                        onSelect={(value) => setSelectedOptions(value)}
                                        style={{ marginTop: 7, marginBottom: 15 }}
                                    />
                                </div>

                                <div>
                                    <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Email Address*</div>
                                    <MuiTextField
                                        variant='outlined'
                                        value={emailAddress}
                                        onChange={(e) => setEmailAddress(e.target.value)}
                                        size="small"
                                        style={{ marginBottom: 20, marginTop: 7 }}
                                    />
                                </div>

                                <div style={{ width: "100%", borderBottom: "1px solid #DEDEDE" }}></div>
                            </div >
                        </SimpleForm >
                    }

                    <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={closeDialog} variant='contained' disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }}>Cancel</Button>
                        <Button
                            className={resolved !== 1 ? classes.errorText : null}
                            variant='contained'
                            onClick={resolved === 1 ? assignHandler : removeHandler}
                            disableElevation
                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", color: "#FFFF", backgroundColor: resolved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main, }}
                        >
                            {resolved === 1
                                ? 'Assign'
                                : 'Remove'}
                        </Button>
                    </DialogActions>
                </Dialog >
            </div >
        </>
    );
}
